import React from 'react';

const DeviceTypeTitle = ({ record }) => {
	return <span>DeviceType {record ? `"${record.name}"` : ''}</span>;
};
export default DeviceTypeTitle;
